export default __webpack_public_path__ + "static/media/36-TimHortons.21db19ca.jpg";